import React from "react";
import { Link } from "react-router";
import classnames from "classnames";

import "./Navigation.css";

const NavigationItem = ({
  children,
  transparent,
  pinned,
  link = "#",
  external = false
}) => {
  const linkClassName = classnames({
    navigationItemLink: true,
    navigationItemLinkTransparent: transparent,
    navigationItemLinkPinned: pinned
  });

  const inner =
    link.startsWith("http") || external ? (
      <a className={linkClassName} href={link}>
        {children}
      </a>
    ) : (
      <Link className={linkClassName} to={link}>
        {children}
      </Link>
    );

  return (
    <li className="navigationItem" data-link={link}>
      {inner}
    </li>
  );
};

export const Navigation = ({ transparent, pinned }) => {
  return (
    <nav>
      <ul className={"navigation"}>
        <NavigationItem transparent={transparent} pinned={pinned} link={"/try"}>
          Try
        </NavigationItem>
        <NavigationItem
          transparent={transparent}
          pinned={pinned}
          link={"https://docs.catalog.style"}
          external
        >
          Docs
        </NavigationItem>
        <NavigationItem
          transparent={transparent}
          pinned={pinned}
          link={"https://github.com/interactivethings/catalog/"}
        >
          Github
        </NavigationItem>
      </ul>
    </nav>
  );
};



// WEBPACK FOOTER //
// ./src/components/Navigation.js